import { type CompanyConfig, TimeFormat } from '../interface';

// TODO: need update!!!
export const OskuhusConfig: CompanyConfig = {
  id: '43e0e0f4-0032-4658-a607-7a8b6ed89013',
  lang: 'en',
  langs: ['en'],
  name: 'Öskuhús',
  nameSecondary: 'Öskuhús',
  currency: '',
  currencyCode: 'GBP',
  officialName: 'Öskuhús',
  email: 'hello@oskuhus.co.uk',
  feedbackEmail: 'hello@oskuhus.co.uk',
  phonePlaceholder: '+44',
  defaultPhoneCode: '+44',
  phoneNumber: '',
  ageRestricted: 21,
  timeZone: 'Europe/London',
  minimalOrderFeeThreshold: 700,
  address: 'Öskuhús Unit, Park Farm, Milton Abbas, Blandford, DT11 0AX',
  canonical: '',
  defaultVolumeDisplay: '1x',
  warehouse: {
    default: 'OSKHS',
    minimalOrderFeeWarehouseCodes: [],
    location: {
      lat: 51.50978861020726,
      lng: -0.12653339657043047,
    },
  },
  map: {
    center: { lat: 51.50978861020726, lng: -0.12653339657043047 },
    zoom: 12,
  },
  paymentMethods: ['cash', 'gpay', 'applepay'],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    // whatsapp: 'https://wa.me/971501515042',
    facebook: 'https://www.facebook.com/Oskuhus/',
    instagram: 'https://www.instagram.com/oskuhus/',
    twitter: 'https://twitter.com/oskuhus/',
    // tiktok: 'https://www.tiktok.com/@citydrinksuae/',
    // youtube: 'https://www.youtube.com/channel/UCzwC746u4WxzAs0fPOMfSMA/',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: 'SWIFFTUCDAVIS',
    discount: '15%',
    minBasket: '15',
    downloadAppLink: 'https://click.jiffy.shop/PZKk/f11c621',
  },
  points: {
    value: '1=1c.',
    pointsPerUnit: 15,
    icon: 'coins',
  },
  appStoreUrl: {
    ios: '',
    android: '',
  },
  apis: {},
  countryCode: 'GB',
  license: {
    name: 'Öskuhús',
    numberPrinary: '',
  },
};
